import * as React from "react";
import {css} from "@emotion/react";

import {Apla} from "@pg-design/apla-module";
import {Button} from "@pg-design/button-module";
import {borderRadius, h100, mt, p, truncate} from "@pg-design/helpers-css";
import {MapMarkerOutlineIcon} from "@pg-design/icons-module";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";

import {OfferBoxBase} from "../../atoms/OfferBoxBase";
import {monthlyOfferClickHit} from "../../tracking/algolytics_hits/monthly_offer_click_hit";
import {getThumbnailLink} from "../../utils/get_thumbnail_link";
import {centerAdCreation} from "../Creation";
import {ICreation} from "../types/ICreation";

interface IProps {
    creation: IMonthlyCreation;
    url: string;
}

export type IMonthlyCreation = Pick<ICreation, "mobile_image_url" | "mobile_name" | "mobile_vendor" | "mobile_region" | "mobile_address">;

export const MonthlyCreation = (props: IProps) => {
    const onMonthlyCreationClick = () => {
        monthlyOfferClickHit(props.url);
        window.open(props.url, "_blank");
    };
    return (
        <OfferBoxBase css={[centerAdCreation, h100]} onClick={onMonthlyCreationClick}>
            <Apla
                css={aplaStyle}
                applyOn={
                    <Image
                        css={borderRadius(2)}
                        alt="creation"
                        width="375"
                        height="484"
                        ratio={{xs: "366/442"}}
                        src={getThumbnailLink(props.creation.mobile_image_url, 375, 484)}
                    />
                }
            >
                <div css={offerBoxBottom}>
                    <div css={textContent}>
                        <Text variant="headline_3" as="h2" css={[offerBoxName, truncate]}>
                            {props.creation.mobile_name}
                        </Text>

                        <Text variant="info_txt_1" as="h3" css={[offerBoxVendorName, truncate]}>
                            {props.creation.mobile_vendor}
                        </Text>

                        <div css={offerBoxAddressHolder}>
                            <div css={offerBoxIconHolder}>
                                <MapMarkerOutlineIcon size="2" fill="#fff" />
                            </div>

                            <address css={[offerBoxAddress]}>
                                <Text variant="body_copy_2" css={truncate}>
                                    {props.creation.mobile_region}
                                    {props.creation.mobile_address && <span css={[truncate, displayBlock]}>{props.creation.mobile_address}</span>}
                                </Text>
                            </address>
                        </div>
                    </div>

                    <Button css={button} variant="stretched_primary">
                        Zobacz inwestycję
                    </Button>
                </div>
            </Apla>
        </OfferBoxBase>
    );
};

const offerBoxBottom = css`
    position: absolute;
    width: 100%;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 0;
    cursor: pointer;
    ${borderRadius(0, 0, 2, 2)}
    overflow: hidden;
`;

const textContent = css`
    ${p(2)}
`;

const button = css`
    width: 100%;
`;

const offerBoxName = css`
    color: white;
`;

const offerBoxVendorName = css`
    ${mt(1)}
    color: white;
`;

const offerBoxAddress = css`
    display: flex;
    flex-direction: column;
    font-style: normal;
    font-size: 1rem;
    width: 100%;
    margin-bottom: 0;
`;

const offerBoxIconHolder = css`
    padding-right: 1rem;
    padding-left: 0.3rem;
`;

const offerBoxAddressHolder = css`
    margin-top: 2.7rem;
    display: flex;
    flex-direction: row;
    color: white;
`;

const displayBlock = css`
    display: block;
`;

const aplaStyle = css`
    ${h100};

    &:after {
        ${borderRadius(2)}
    }
`;
import * as React from "react";
import {css} from "@emotion/react";

import {Apla} from "@pg-design/apla-module";
import {Button} from "@pg-design/button-module";
import {borderRadius, h100, mt, p, truncate} from "@pg-design/helpers-css";
import {MapMarkerOutlineIcon} from "@pg-design/icons-module";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";

import {OfferBoxBase} from "../../atoms/OfferBoxBase";
import {monthlyOfferClickHit} from "../../tracking/algolytics_hits/monthly_offer_click_hit";
import {getThumbnailLink} from "../../utils/get_thumbnail_link";
import {centerAdCreation} from "../Creation";
import {ICreation} from "../types/ICreation";

interface IProps {
    creation: IMonthlyCreation;
    url: string;
}

export type IMonthlyCreation = Pick<ICreation, "mobile_image_url" | "mobile_name" | "mobile_vendor" | "mobile_region" | "mobile_address">;

export const MonthlyCreation = (props: IProps) => {
    const onMonthlyCreationClick = () => {
        monthlyOfferClickHit(props.url);
        window.open(props.url, "_blank");
    };
    return (
        <OfferBoxBase css={[centerAdCreation, h100]} onClick={onMonthlyCreationClick}>
            <Apla
                css={aplaStyle}
                applyOn={
                    <Image
                        css={borderRadius(2)}
                        alt="creation"
                        width="375"
                        height="484"
                        ratio={{xs: "366/442"}}
                        src={getThumbnailLink(props.creation.mobile_image_url, 375, 484)}
                    />
                }
            >
                <div css={offerBoxBottom}>
                    <div css={textContent}>
                        <Text variant="headline_3" as="h2" css={[offerBoxName, truncate]}>
                            {props.creation.mobile_name}
                        </Text>

                        <Text variant="info_txt_1" as="h3" css={[offerBoxVendorName, truncate]}>
                            {props.creation.mobile_vendor}
                        </Text>

                        <div css={offerBoxAddressHolder}>
                            <div css={offerBoxIconHolder}>
                                <MapMarkerOutlineIcon size="2" fill="#fff" />
                            </div>

                            <address css={[offerBoxAddress]}>
                                <Text variant="body_copy_2" css={truncate}>
                                    {props.creation.mobile_region}
                                    {props.creation.mobile_address && <span css={[truncate, displayBlock]}>{props.creation.mobile_address}</span>}
                                </Text>
                            </address>
                        </div>
                    </div>

                    <Button css={button} variant="stretched_primary">
                        Zobacz inwestycję
                    </Button>
                </div>
            </Apla>
        </OfferBoxBase>
    );
};

const offerBoxBottom = css`
    position: absolute;
    width: 100%;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 0;
    cursor: pointer;
    ${borderRadius(0, 0, 2, 2)}
    overflow: hidden;
`;

const textContent = css`
    ${p(2)}
`;

const button = css`
    width: 100%;
`;

const offerBoxName = css`
    color: white;
`;

const offerBoxVendorName = css`
    ${mt(1)}
    color: white;
`;

const offerBoxAddress = css`
    display: flex;
    flex-direction: column;
    font-style: normal;
    font-size: 1rem;
    width: 100%;
    margin-bottom: 0;
`;

const offerBoxIconHolder = css`
    padding-right: 1rem;
    padding-left: 0.3rem;
`;

const offerBoxAddressHolder = css`
    margin-top: 2.7rem;
    display: flex;
    flex-direction: row;
    color: white;
`;

const displayBlock = css`
    display: block;
`;

const aplaStyle = css`
    ${h100};

    &:after {
        ${borderRadius(2)}
    }
`;
